_ = require 'underscore'

{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
Util = require 'app/scripts/lib/util'

BoardCleanUpView = require 'app/scripts/views/board/board-clean-up-view'
Auth = require 'app/scripts/db/auth'
l = require 'app/scripts/lib/localize'
headerTemplate = require 'app/scripts/views/templates/board_header'
CopyBoardHeaderButtonTeams = require 'app/scripts/data/copy-board-header-button-teams'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ logoDomain } = require '@trello/config'
Dialog = require 'app/scripts/views/lib/dialog'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ BoardViewsButton } = require 'app/src/components/BoardViewsButton'
Controller = require 'app/scripts/controller'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'

MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
CALENDAR_POWER_UP_ID = LegacyPowerUps.calendar


module.exports.renderBoardHeader = ->
  isPremOrgAdmin = @model.isPremOrgAdmin(Auth.me())
  workspacesPreambleEnabled = featureFlagClient.get('btg.workspaces-preamble', false)

  data =
    name: @model.get('name')
    canRename: isPremOrgAdmin || @model.owned()
    isLoggedIn: Auth.isLoggedIn()
    isAdmin: @model.ownedByMember(Auth.me())
    isMember: @model.isMember(Auth.me())
    isPrivateTeam: @model.hasOrganization() && !@model.getOrganization()
    isPrivateTeamForEnterpriseVisibleBoard: @model.hasOrganization() && @model.getPref('permissionLevel') == 'enterprise'
    isUntitled: @model.get('name') == l(['untitled board'])
    canJoin: @model.canJoin()
    canInviteMembers: @model.canInviteMembers()
    selfJoin: @model.allowsSelfJoin()
    canAssign: @model.editable()
    boardCardCount: @model.openCards()?.filter((card) => @model.filter.satisfiesFilter(card)).length
    isTemplate: @model.isTemplate()
    boardViewsButtonEnabled: featureFlagClient.get('remarkable.board-views-button', false)
    workspacesPreambleEnabled: workspacesPreambleEnabled

  if @calendarView?
    data.currentBoardView = 'calendar'
  else if @mapView?
    data.currentBoardView = 'map'
  else
    data.currentBoardView = 'list'

  data.starTooltipKey = if @model.isTemplate()
      'click-to-star-or-unstar-this-template-starred-templates-show-up-at-the-top-of-your-boards-list'
    else
      'click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list'

  organization = @model.getOrganization()
  if organization?
    data.orgDisplayName = organization.get('displayName')
    data.orgName = organization.get('name')
    data.showCopyButton = _.contains(CopyBoardHeaderButtonTeams, organization.id)
    _hash = organization.get('logoHash')
    enterprise_hash = organization.getEnterprise()?.get('logoHash')
    if enterprise_hash && featureFlagClient.get('enterprise.corporate-visibility', false)
      data.orgLogoUrl = "#{logoDomain}/#{enterprise_hash}/30.png"
      data.orgLogoUrl2x = "#{logoDomain}/#{enterprise_hash}/170.png"
    else if _hash
      data.orgLogoUrl = "#{logoDomain}/#{_hash}/30.png"
      data.orgLogoUrl2x = "#{logoDomain}/#{_hash}/170.png"
    data.hasBusinessClass = organization.isPremium()
    data.isBusinessClass = organization.isBusinessClass()
    data.isEnterprise = organization?.get('idEnterprise')

  @$('.js-board-header').html headerTemplate(data)

  if workspacesPreambleEnabled
    @renderWorkspacesPreambleBoardHeaderButton()
    @renderWorkspacesPreambleInviteButton()

  @renderPermissionLevel()
  @renderBoardHeaderCalendar()
  @renderBoardHeaderSubscribed()
  @renderBoardHeaderMap()
  @renderFilteringStatus()
  @renderBoardHeaderStarred()
  @renderPluginButtons()
  @renderBoardHeaderFacepile()
  @renderBoardBackgroundPromptPopover()
  @renderBoardTemplateBadge()
  @renderBoardViewsButton()

  @

module.exports.renderBoardHeaderStarred = ->
  @$('.js-star-board').toggleClass('board-header-btn-enabled', @model.isStarred())
  @

module.exports.toggleStarred = ->
  boardStarList = Auth.me().boardStarList

  if boardStarList.getBoardStar(@model.id)?
    boardStarList.unstarBoard(@model.id)
    track("Board Header", "Unstar Board")
  else
    boardStarList.starBoard(@model.id)
    track("Board Header", "Star Board")

  Analytics.sendUpdatedBoardFieldEvent
    field: 'star',
    value: !!boardStarList.getBoardStar(@model.id),
    source: 'boardScreen',
    containers:
      board:
        id: @model.id

  @

module.exports.openFilter = (e) ->
  Util.stop(e)
  track("Board Header", "Open Filtering via Header")
  if @sendGASEvent
    Analytics.sendClickedButtonEvent
      buttonName: 'boardFilterButton'
      source: 'boardScreen'

  @sidebarView.pushView 'filter'
  return

module.exports.clearFilters = (e) ->
  Util.stop(e)
  track("Board Header", "Clear Filtering via Header")
  if @sendGASEvent
    Analytics.sendClickedButtonEvent
      buttonName: 'clearBoardFilterButton'
      source: 'boardScreen'

  @model.filter.clear()
  return

module.exports.showCleanUp = (e) ->
  Util.stop(e)

  track("Board Header", "Show Clean-Up")

  view = new BoardCleanUpView({ @model, @modelCache })
  Dialog.show
    view: view
    maxWidth: 800
    hide: ->
      view.abort()

  return

module.exports.renderBoardViewsButton = ->
  if !featureFlagClient.get('remarkable.board-views-button', false)
    return

  renderBoardViewsButtonWithReact = =>
    if @calendarView?
      currentView = 'calendar'
    else if @mapView?
      currentView = 'map'
    else
      currentView = 'list'

    isCalendarPowerUpAllowed = true
    isMapPowerUpAllowed = true

    if @model.isEnterpriseBoard()
      enterprise = @model.getEnterprise()
      if enterprise?
        isCalendarPowerUpAllowed = enterprise.isPluginAllowed(CALENDAR_POWER_UP_ID)
        isMapPowerUpAllowed = enterprise.isPluginAllowed(MAP_POWER_UP_ID)

    orgName = undefined

    if @model.hasOrganization()
      orgName = @model.getOrganization()?.get('name')

    me = Auth.me()

    renderComponent(React.createElement(BoardViewsButton, {
      currentView: currentView
      orgName: orgName
      isCalendarPowerUpEnabled: @model.isPowerUpEnabled('calendar')
      isMapPowerUpEnabled: @model.isMapPowerUpEnabled()
      hasReachedPowerUpLimit: !@model.canEnableAdditionalPowerUps()
      onPublicBoard: @model.isPublic()
      boardEditable: @model.editable()
      isCalendarPowerUpAllowed: isCalendarPowerUpAllowed
      isMapPowerUpAllowed: isMapPowerUpAllowed
      isObserver: me? && @model.isObserver(me)
      navigateToListView: =>
        boardUrl = Controller.getBoardUrl(@model.id)
        Controller.navigate boardUrl, { trigger: true }
        return true
      navigateToCalendarView: =>
        calendarBoardUrl = Controller.getBoardUrl(@model.id, 'calendar')
        if @model.isPowerUpEnabled('calendar')
          Controller.navigate calendarBoardUrl, { trigger: true }
          return true
        else if @model.editable()
          if !isCalendarPowerUpAllowed
            return false
          @model.enablePlugin(CALENDAR_POWER_UP_ID)
            .then => Controller.navigate calendarBoardUrl, { trigger: true }
          return true
        return false
      navigateToMapView: =>
        mapBoardUrl = Controller.getBoardUrl(@model.id, 'map')
        if @model.isMapPowerUpEnabled()
          Controller.navigate mapBoardUrl, { trigger: true }
          return true
        else if @model.editable()
          if !isMapPowerUpAllowed
            return false
          @model.enablePlugin(MAP_POWER_UP_ID)
            .then => Controller.navigate mapBoardUrl, { trigger: true }
          return true
        return false
      preloadPlugins: =>
        @model.getAvailablePlugins()
    }), @$('.js-board-views-btn-container')[0])

  if !@boardViewsButtonPreviouslyRender
    # Defer here since the target div that is being rendered by Backbone may
    # not be available yet.
    _.defer =>
      renderBoardViewsButtonWithReact()
      @boardViewsButtonPreviouslyRender = true
  else
    renderBoardViewsButtonWithReact()

  return

module.exports.removeBoardViewsButton = ->
  if featureFlagClient.get('remarkable.board-views-button', false)
    if @$('.js-board-views-btn-container').length
      ReactDOM.unmountComponentAtNode(@$('.js-board-views-btn-container')[0])
